import { API_BASE_URL } from "@/libs/apis/commons";

export const CONTENTFUL_BASE_URL = `${API_BASE_URL}/content/pages`;
export const CONTENT_COLLECTIONS_BASE_URL = `${API_BASE_URL}/content/collections`;
